// @ts-check
import React from 'react';
// import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

// We currently only need to store if it's enabled or not.
const AnalyticsContext = React.createContext({ isEnabled: true });

export const AnalyticsProvider = AnalyticsContext.Provider;

/**
 * Track an event with analytics.
 * @callback Track
 * @param {string} event What happened.
 * @param {object} [properties] Additional properties.
 */
/**
 * @returns {Track} a function to track an event.
 */
export function useTrack() {
  const { isEnabled } = React.useContext(AnalyticsContext);
  return function track(event, properties) {
    if (!isEnabled) return;
    const { category = 'User', label, ...rest } = properties || {};
    // ReactGA.event({ category, action: event, label, ...rest });
  };
}

export function usePageViews(category, name, properties, options) {
  let location = useLocation();
  const { isEnabled } = React.useContext(AnalyticsContext);
  React.useEffect(() => {
    if (!isEnabled) return;
    // ReactGA.pageview(location.pathname);
  }, [isEnabled, location.pathname]);
}
